import React from "react"
import { connect } from "react-redux"
import actions from "./actions/root_action"
import StringHelper from "../../common/helpers/string_helper"
import AddressHelper from '../../common/helpers/address_helper'
import Photo from "./Photo"
import Outline from "./Outline"
import Description from "./Description"
import BedTypes from "./BedTypes"
import Amenity from "./Amenity"
import RoomInfo from "./RoomInfo"
import PriceInfo from "./PriceInfo"
import HomeSafety from "./HomeSafety"
import HouseRule from "./HouseRule"
import DisinfectionMeasureContainer from "./DisinfectionMeasureContainer"
import Reviews from "./Reviews"
import Access from "./Access"
import HostInfo from "./HostInfo"
import Calendar from "./Calendar"
import CurrencyHelper from "../../common/helpers/currency_helper"
// import Navigation from "./navigation_component"
import "./main_container.scss"

const REVIEWS_PER_PAGE = 5 // ページあたりのレビュー件数

export class Main extends React.Component {
  constructor(props) {
    super(props)
    this.props.listing.room_group_id = Number(
      this.props.match.params.room_group_id
    )
    this.state = {
      room_group_id: Number(this.props.match.params.room_group_id),
      preferred_language: navigator.language || navigator.userLanguage,
      error: ""
    }
  }

  componentDidMount() {
    this.props.actions.listing.get()
    this.props.actions.cancelPolicies.get()
    this.props.actions.search.get({
      room_group_id: this.props.listing.room_group_id,
      currency_code: CurrencyHelper.metaCurrencyCode()
    })
    this.props.actions.review.forListing(
      this.props.match.params.room_group_id,
      { limit: REVIEWS_PER_PAGE, offset: 0 }
    )
    this.props.actions.bedTypes.bedTypeOptions()
    this.props.actions.propertyTypes.get()
    this.appendBreadcrumbList()
  }

  get totalReviewPages() {
    if (!this.props.reviews.pagination) {
      return 0
    }
    return Math.ceil(this.props.reviews.pagination.total / REVIEWS_PER_PAGE)
  }

  componentDidUpdate() {
    this.appendBreadcrumbList()
  }

  appendBreadcrumbList() {
    const { breadcrumbListContainer } = this.refs
    const { breadcrumbList } = Main
    if (breadcrumbList) {
      if (breadcrumbListContainer) {
        if (breadcrumbList.parentElement != breadcrumbListContainer) {
          breadcrumbListContainer.appendChild(breadcrumbList)
        }
      } else if (breadcrumbList.parentElement) {
        breadcrumbList.parentElement.removeChild(breadcrumbList)
      }
    }
  }

  get reviewCount() {
    return (
      (this.props.listing &&
        this.props.listing.review_stats &&
        this.props.listing.review_stats.overall_stats &&
        this.props.listing.review_stats.overall_stats.count) ||
      0
    )
  }

  handleReviewPage(page) {
    this.props.actions.review
      .forListing(this.props.match.params.room_group_id, {
        limit: REVIEWS_PER_PAGE,
        offset: page * REVIEWS_PER_PAGE
      })
      .then(() => {
        setTimeout(() => {
          const container = document.querySelector("#review")
          if (container.scrollIntoView) {
            container.scrollIntoView({ block: "start", behavior: "smooth" })
          } else {
            window.scrollTo(0, container.offsetTop || 0)
          }
        })
      })
  }

  get propertyAddressElement() {
    const {
      prefecture,
      city,
      street_address,
      apt_name,
      country_code,
      country
    } = this.props.listing.property

    return (
      AddressHelper.address(
        prefecture,
        city,
        street_address,
        apt_name,
        languageHelper.pageLocale,
        country_code,
        country
      )
    )
  }

  get gMapUrl() {
    const property = this.props.listing.property

    if (property.lat && property.lon) {
      const lat = Number(property.lat)
      const lon = Number(property.lon)
      return `https://www.google.com/maps/place/${lat},${lon}/@${lat},${lon},14z`
    } else {
      return ''
    }
  }

  render() {
    return (
      <div styleName="contents-wrapper">
        {this.props.listing && this.props.listing.room_type && (
          <React.Fragment>
            <Photo photos={this.props.listing.photos || []} />
            <div styleName="contents">
              <div styleName="roomgroup-info">
                {/* <Navigation reviewCount={this.reviewCount} /> */}
                <section id="outline">
                  <Outline
                    property_type={
                      this.props.propertyTypes.property_types[this.props.listing.property.property_type]
                    }
                    room_title={StringHelper.getPreferredLanguageString(
                      this.props.listing.room_title,
                      languageHelper.pageLocale
                    )}
                    property_title={StringHelper.getPreferredLanguageString(
                      this.props.listing.property.title,
                      languageHelper.pageLocale
                    )}
                    room_type={this.props.listing.room_type}
                    room_type_localized={this.props.listing.room_type_localized}
                    maximum_guests={this.props.listing.maximum_guests}
                    beds={this.props.listing.beds}
                    bedrooms={this.props.listing.bedrooms}
                    is_shared_bath={this.props.listing.is_shared_bath}
                    bathrooms={this.props.listing.bathrooms}
                    size={this.props.listing.size}
                    addressElement={this.propertyAddressElement}
                    gMapUrl={this.gMapUrl}
                  />

                  <Description
                    roomInfo={StringHelper.getPreferredLanguageString(
                      this.props.listing.description,
                      languageHelper.pageLocale
                    )}
                    propertyInfo={StringHelper.getPreferredLanguageString(
                      this.props.listing.property.description,
                      languageHelper.pageLocale
                    )}
                  />
                </section>
                <BedTypes
                  bedTypes={this.props.bedTypes}
                  bedding={this.props.listing.bed_types}
                />
                <Amenity amenities_list={this.props.listing.amenities_list} />
                <RoomInfo
                  checkin_from={
                    this.props.listing.reservation_requirement.checkin_from
                  }
                  checkin_to={
                    this.props.listing.reservation_requirement.checkin_to
                  }
                  checkout_to={
                    this.props.listing.reservation_requirement.checkout_to
                  }
                  minimum_stays={
                    this.props.listing.reservation_requirement.minimum_stays
                  }
                  maximum_stays={
                    this.props.listing.reservation_requirement.maximum_stays
                  }
                  available_room_codes={
                    this.props.listing.available_room_codes
                  }
                  law_type={this.props.listing.law_type}
                />
                <PriceInfo
                  price_for_extra_person={
                    this.props.listing.basic_price_setting
                      .price_for_extra_person
                  }
                  persons_for_extra_fee={
                    this.props.listing.basic_price_setting
                      .persons_for_extra_fee
                  }
                  cancel_policy={this.props.listing.cancel_policy || ""}
                  scheduled_cancel_policies={this.props.listing.scheduled_cancel_policies || []}
                  cancel_policy_list={
                    this.props.cancelPolicies.cancel_policy_list
                  }
                />
                <HomeSafety
                  home_safeties={this.props.listing.home_safeties}
                />
                <HouseRule
                  typical_house_rules={this.props.listing.typical_house_rules}
                  additional_house_rule={StringHelper.getPreferredLanguageString(
                    this.props.listing.house_rule,
                    languageHelper.pageLocale
                  )}
                />
                <DisinfectionMeasureContainer listing={this.props.listing} />

                {this.reviewCount > 0 && (
                  <Reviews
                    stats={this.props.listing.review_stats}
                    reviews={this.props.reviews}
                    reviewCount={this.reviewCount}
                    totalPages={this.totalReviewPages}
                    onPageChange={({ selected }) =>
                      this.handleReviewPage(selected)
                    }
                  />
                )}
                <Access
                  lang={languageHelper.pageLocale}
                  lat={Number(this.props.listing.property.lat || "35.681167")}
                  lon={Number(this.props.listing.property.lon || "139.767052")}
                  prefecture={this.props.listing.property.prefecture}
                  city={this.props.listing.property.city}
                  street_address={this.props.listing.property.street_address}
                  apt_name={this.props.listing.property.apt_name}
                  address={this.props.listing.property.address}
                  country={this.props.listing.property.country}
                  country_code={this.props.listing.property.country_code}
                />
                <HostInfo
                  host={this.props.listing.user || {}}
                />
              </div>
              <div styleName="sidebar">
                <div styleName="sidebar-content">
                  <Calendar
                    search={this.props.location.search}
                    room_group_id={this.props.listing.room_group_id}
                    minimum_price={
                      this.props.search.room_groups == null ||
                      this.props.search.room_groups.length == 0
                        ? 0
                        : this.props.search.room_groups[0].min_price
                    }
                    base_price={
                      this.props.listing.basic_price_setting.base_price
                    }
                    maximum_guests={this.props.listing.maximum_guests}
                    accept_days={
                      this.props.listing.reservation_requirement.accept_days
                    }
                    accept_days_hour={
                      this.props.listing.reservation_requirement
                        .accept_days_hour
                    }
                    is_instant_booking={
                      this.props.listing.reservation_requirement
                        .is_instant_booking
                    }
                    minimum_stays={
                      this.props.listing.reservation_requirement.minimum_stays
                    }
                    maximum_stays={
                      this.props.listing.reservation_requirement.maximum_stays
                    }
                    discount_rate={
                      this.props.listing.basic_price_setting.weekly_discount
                    }
                    interval_days={
                      this.props.listing.reservation_requirement.interval_days
                    }
                    lang={languageHelper.pageLocale}
                    login={this.props.login}
                    modal={this.props.modal}
                    loginActions={this.props.actions.login}
                    modalActions={this.props.actions.modal}
                    is_preview={false}
                    timezone={this.props.listing.property.timezone}
                    allowInfants={this.props.listing.allow_infants}
                    countryCode={this.props.listing.property.country_code}
                  />
                </div>
              </div>
            </div>
            <div ref="breadcrumbListContainer"></div>
          </React.Fragment>
        )}
      </div>
    )
  }

  static get breadcrumbList() {
    return this._breadcrumbList
      ? this._breadcrumbList
      : (this._breadcrumbList = document.querySelector(".js-breadcrumb-list"))
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    language: state.language,
    listing: state.listing,
    cancelPolicies: state.cancelPolicies,
    search: state.search,
    reviews: state.reviews,
    bedTypes: state.bedTypes,
    modal: state.modal,
    propertyTypes: state.propertyTypes
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
